module.exports = __webpack_public_path__ + "static/media/headshot.653fe384.jpg";